import React from 'react'
import styled from 'styled-components'
import { colors } from '../../../styles/theme'
import AboutOrganizer from './organizer/about-organizer'
import EventPerformances from './event-performances'
import breakpoints from '../../../styles/breakpoints'
import EventLocation from './event-location'

const StyledEventSidebar = styled.section`
  border-radius: 2px;

  @media (min-width: ${breakpoints.lg}) {
    background-color: ${colors.neutral100};
    border: 1px solid ${props => props.theme.colors.separator};
    box-shadow: 0 2px 2px rgba(0, 0, 0, 0.1);
    padding: ${props => props.theme.spacing.base500} ${props => props.theme.spacing.base400};
  }
`

const EventSidebar = ({ ...props }) => {
  return (
    <StyledEventSidebar {...props}>
      <EventPerformances />
      <EventLocation />
      <AboutOrganizer />
    </StyledEventSidebar>
  )
}

export default EventSidebar
